import * as base from 'utils/preprocessScreenings.js';
// import { accessNested } from 'utils/utils';

// Proper capitalizations
let titles = {
	'fleabag': 'Fleabag',
	'the lehman trilogy': 'The Lehman Trilogy',
	'present laughter': 'Present Laughter',
	'hansard': 'Hansard',
	'no man\'s land': 'No Man\'s Land',
	'frankenstein': 'Frankenstein',
	'a midsummer night\'s dream': 'A Midsummer Night\'s Dream',
	'all my sons': 'All My Sons',
	'a view from the bridge': 'A View from the Bridge',
	'king lear': 'King Lear',
	'coriolanus': 'Coriolanus',
};

export default function(data, included, appData, ...args) {
	let baseResults = typeof base.default === 'function' && base.default(data, included, appData, ...args);
	if (baseResults && baseResults.data) data = baseResults.data;
	if (baseResults && baseResults.included) included = baseResults.included;

	included.forEach(inc => {
		let title = inc.attributes && inc.attributes.title;
		if (inc.type === 'movies' && inc.attributes.title) {
			// title = title.replace(/ \((encore|live)(\s+\d+)?\)$/i, '');
			title = title.replace(/ \([^)]*\)/ig, '');
			title = title.replace(/ encore( \d+)?(?= - |$)/i, '');
			title = title.replace(/ - [a-z-]+ as creature$/i, '');
			title = title.replace(/ 20[012]\d$/i, '');
			title = title.replace(/: live film premiere$/i, '');
			inc.attributes.title = titles[title.toLowerCase()] || title;
		}
	});

	return {
		data: data,
		included: included
	};
}
